<template>
  <v-form>
    <v-container fluid>
      <v-row>
        <v-col cols="12" sm="6" md="6">
          <v-text-field
            v-model="item.name"
            :error-messages="nameErrors"
            :label="$t('global.name')"
            required
            @input="$v.item.name.$touch()"
            @blur="$v.item.name.$touch()"
          />
        </v-col>
        <v-col cols="12" sm="6" md="6">
          <v-combobox
            v-if="macrotypeSelectItems"
            v-model="item.parent"
            :items="macrotypeSelectItems"
            :error-messages="parentErrors"
            :no-data-text="$t('global.no_result')"
            :placeholder="$t('global.no_select')"
            clearable
            :label="$t('global.parent')"
            item-text="name"
            item-value="@id"
          />
        </v-col>

      </v-row>
      <v-row>

        <v-col cols="12" sm="6" md="6">
          <v-row align="center">
            <v-col md="8" >
              <strong class="ml-4" >{{ $t('macro.loadprocess') }}:</strong>
            </v-col>
            <v-col md="4">
              <v-switch
                v-model="item.loadprocess"
                :error-messages="initErrors"
              ></v-switch>
            </v-col>
          </v-row>
        </v-col>

      </v-row>
    </v-container>
    <Loading :visible="isLoading" />
  </v-form>
</template>

<script>
import has from 'lodash/has';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { mapActions } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';

export default {
  name: 'MacroTypeForm',
  mixins: [validationMixin],
  components: {
    Loading
  },
  props: {
    values: {
      type: Object,
      required: true
    },

    errors: {
      type: Object,
      default: () => {}
    },

    initialValues: {
      type: Object,
      default: () => {}
    }
  },
  mounted() {
    this.macrotypeGetSelectItems();
  },
  data() {
    return {
        name: null,
        parent: null,
        loadprocess: null,
    };
  },
  computed: {
    isLoading() {
        return (this.isLoading_macrotype
         );
      },
      ...mapFields('macrotype', {
        macrotypeSelectItems: 'selectItems',
        isLoading_macrotype : 'isLoading'
      }),
    // eslint-disable-next-line
    item() {
      return this.initialValues || this.values;
    },

    nameErrors() {
      const errors = [];
      if (!this.$v.item.name.$dirty) return errors;
      has(this.violations, 'name') && errors.push(this.violations.name);
      !this.$v.item.name.required && errors.push(this.$t('global.field_required'));
      return errors;
    },

    loadprocessErrors() {
      const errors = [];
      if (!this.$v.item.loadprocess.$dirty) return errors;
      has(this.violations, 'loadprocess') && errors.push(this.violations.loadprocess);
      return errors;
    },
    parentErrors() {
      const errors = [];
      if (!this.$v.item.parent.$dirty) return errors;
      has(this.violations, 'parent') && errors.push(this.violations.parent);
      return errors;
    },
    violations() {
      return this.errors || {};
    }
  },
  methods: {
    ...mapActions({
        macrotypeGetSelectItems: 'macrotype/fetchSelectItems'
      }),
  },
  validations: {
    item: {
      name: {
        required,
      },
      parent: {
      },
      loadprocess: {

      },
    }
  }
};
</script>
